import { ArrowRight, BadgeCheck, ShieldCheck, Star } from "lucide-react";

/**
 * Mobile-only ($lt; md) offer hero for the Meta ads LP.
 * Order: eyebrow → $150 offer headline → supporting copy → full-width CTA
 * (scrolls to the existing form, no redirect) → compact trust row → photo.
 * Desktop/tablet never render this — the classic hero stays untouched.
 */
export default function MobileOfferHero({ formId, trackLocation, testidPrefix }) {
  const scrollToForm = () => {
    document.getElementById(formId)?.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <div data-testid={`${testidPrefix}-mobile-offer-hero`} className="md:hidden order-1">
      <div className="eyebrow eyebrow-red">Prescott Area Homeowners</div>

      <h1 className="h-display uppercase mt-3 leading-[0.95]">
        <span className="block" style={{ fontSize: "clamp(28px, 9vw, 36px)" }}>Save</span>
        <span className="block text-[var(--red)]" style={{ fontSize: "clamp(56px, 17vw, 72px)" }}>$150 OFF</span>
        <span className="block" style={{ fontSize: "clamp(24px, 8vw, 32px)" }}>Residential Window Tint</span>
      </h1>

      <p className="mt-4 text-sm text-neutral-600 leading-relaxed">
        Reduce harsh glare, block damaging UV rays, and enjoy more privacy without sacrificing the natural light you love.
      </p>

      <button
        type="button"
        onClick={scrollToForm}
        data-testid={`${testidPrefix}-mobile-hero-cta`}
        data-track="lp_cta_click"
        data-track-location={`${trackLocation}-mobile-hero`}
        className="btn-red w-full justify-center !py-4 mt-5 text-base"
      >
        Claim My $150 Discount <ArrowRight size={16} />
      </button>

      <div className="mt-4 flex flex-wrap items-center gap-x-4 gap-y-1.5 text-xs text-neutral-600">
        <span className="flex items-center gap-1.5">
          <Star size={13} className="text-amber-500 fill-amber-500" /> 5-Star Google Rating
        </span>
        <span className="flex items-center gap-1.5">
          <BadgeCheck size={13} className="text-[var(--red)]" /> 13+ Years of Experience
        </span>
        <span className="flex items-center gap-1.5">
          <ShieldCheck size={13} className="text-[var(--red)]" /> 100% Manufacturer Warranty
        </span>
      </div>

      <div className="mt-5 rounded-3xl overflow-hidden border border-neutral-200 aspect-[4/3] bg-neutral-100">
        <img
          src="/images/lp-res-tint-hero.jpg"
          width={1080}
          height={810}
          alt="928 Wraps installer applying ceramic window film to residential patio doors in Prescott, AZ"
          loading="eager"
          decoding="async"
          className="w-full h-full object-cover"
        />
      </div>
    </div>
  );
}
